
export function formatDynamicKey(dynamicKey) {
    // Use a regular expression to match each word in the dynamicKey
    // and capitalize the first letter of each word
    return dynamicKey.replace(/([a-z])([A-Z])/g, '$1 $2')
                     .replace(/^./, str => str.toUpperCase());
  }